import { useState, useEffect } from 'react';
import { getApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot } from 'firebase/firestore';

let _db = null;
const db = () => {
  if (!_db) {
    try { _db = getFirestore(getApp()); } catch (_) {}
  }
  return _db;
};

/** Live list of admin-created departments plus whether the first snapshot has arrived. */
export function useDepartmentsState() {
  const [state, setState] = useState({ depts: [], loaded: false });

  useEffect(() => {
    const firestore = db();
    if (!firestore) { setState({ depts: [], loaded: true }); return undefined; }
    return onSnapshot(
      collection(firestore, 'departments'),
      snap => setState({
        depts: snap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .sort((a, b) => (a.name || a.id).localeCompare(b.name || b.id)),
        loaded: true,
      }),
      () => setState({ depts: [], loaded: true }),
    );
  }, []);

  return state;
}

/** Live list of admin-created departments (departments/{deptId}), sorted by name. */
export function useDepartments() {
  return useDepartmentsState().depts;
}
